import { ContainerModule, interfaces } from 'inversify';
import { CursorControlBl, ICursorControlBl } from './CursorControl.bl';

export const cursorControlModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(ICursorControlBl.$).to(CursorControlBl).inRequestScope();
});
